import React from 'react'

export interface SVGInstagramProps {
  width?: string;
  height?: string;
  color?: string;
}

export const SVGInstagram = ({
  width = '32',
  height = '32',
  color = '#000000',
}: SVGInstagramProps) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.455 0C4.24 0 0 4.24 0 9.455v13.09C0 27.76 4.24 32 9.455 32h13.09C27.76 32 32 27.76 32 22.546V9.455C32 4.24 27.76 0 22.546 0zm15.272 5.818c.8 0 1.455.655 1.455 1.455s-.655 1.454-1.455 1.454-1.454-.654-1.454-1.454.654-1.455 1.454-1.455M16 8c4.415 0 8 3.585 8 8s-3.585 8-8 8c-4.414 0-8-3.585-8-8 0-4.414 3.585-8 8-8m0 1.455A6.555 6.555 0 0 0 9.455 16 6.555 6.555 0 0 0 16 22.546 6.555 6.555 0 0 0 22.546 16 6.555 6.555 0 0 0 16 9.455" fill={color}/>
  </svg>
)
